import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=3aad85a6&scoped=true"
import script from "./Forgot.vue?vue&type=script&lang=ts"
export * from "./Forgot.vue?vue&type=script&lang=ts"
import style0 from "./Forgot.vue?vue&type=style&index=0&id=3aad85a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aad85a6",
  null
  
)

export default component.exports